// extracted by mini-css-extract-plugin
export default {"threadsPage":"threads_threadsPage__yj5ER"};